module.exports = "/images/body-bg.jpg?9f5e83d3df9bf42f4cc0b23b28d72c45";